export const SPORT_ORDER = [
    "football",
    "basketball",
    "tennis",
    "americanFootball",
    "hockey",
    "baseball",
  ];
  